var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "accessoriesDisplay" } },
    [
      _vm.showAccessoryBloc
        ? _c(
            "div",
            { staticClass: "row" },
            _vm._l(_vm.accessories, function (accessory, index) {
              return _c(
                "article",
                {
                  key: index,
                  staticClass:
                    "col-12 col-md-6 col-xl-4 selector-accessory-card mb-1 d-flex flex-column",
                },
                [
                  _c("selector-accessories-card", {
                    staticClass: "pt-2 px-1",
                    attrs: {
                      id: accessory.versions[0].idSeo.value,
                      accessory: accessory,
                    },
                    on: {
                      "ob1-cards-click": function ($event) {
                        return _vm.loadAccessory(accessory)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.showDasTooltip(accessory) ||
                  _vm.showFundingDetailsLink(accessory)
                    ? _c(
                        "div",
                        { staticClass: "d-flex payment-solutions-details" },
                        [
                          _vm.showDasTooltip(accessory)
                            ? _c("das-tooltip", {
                                attrs: {
                                  id: "tooltip-accessory" + index,
                                  das: accessory.dasAccessible,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFundingDetailsLink(accessory)
                            ? _c("FundingDetailsLink", {
                                staticClass: "ms-auto",
                                attrs: {
                                  "seo-id": accessory.versions[0].idSeo.value,
                                  text: _vm.fundingDetailsDto.linkText,
                                },
                                on: {
                                  fundingDetailsClick:
                                    _vm.handleFundingDetailsClick,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "mb-1" }),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showAccessorySpinner
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center" },
            [
              _c("ob1-progress-indicators", {
                attrs: { type: "undetermined", size: 50 },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex justify-content-center my-2" }, [
        _vm.showMoreAccessoriesButton
          ? _c(
              "button",
              {
                staticClass: "btn btn-secondary mx-0",
                attrs: {
                  id: "showMoreButton",
                  disabled: _vm.showAccessorySpinner,
                },
                on: {
                  click: function ($event) {
                    return _vm.fetchMoreAccessories()
                  },
                },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.wordingButtonMoreAccessories) +
                    "\n        "
                ),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.selectedFundingDetailVersion
        ? _c("pxf-cb4x-modal", {
            attrs: {
              "modal-id": "funding-details-popin",
              "display-cb4x": _vm.selectedFundingDetailVersion.isCb4xAvailable,
              "display-pxf": _vm.selectedFundingDetailVersion.isPxfAvailable,
            },
            scopedSlots: _vm._u(
              [
                _vm.selectedFundingDetailVersion.isCb4xAvailable
                  ? {
                      key: "cb4x-content",
                      fn: function () {
                        return [
                          _vm.fundingDetailsDto.cb4xPopin.withFees
                            ? _c("paying-detail-cb4x-modal-content", {
                                attrs: {
                                  "modal-id": "funding-details-popin",
                                  "oney-merchant-guid":
                                    _vm.fundingDetailsDto.cb4xPopin
                                      .oneyMerchantGuid,
                                  "oney-widget-src":
                                    _vm.fundingDetailsDto.oneyWidgetSrc,
                                  "counter-delay":
                                    _vm.fundingDetailsDto.counterDelay,
                                  amount:
                                    _vm.selectedFundingDetailVersion
                                      .discountedPriceInCents / 100,
                                  "header-block":
                                    _vm.fundingDetailsDto.cb4xPopin.headerBlock,
                                  "how-to-benefit":
                                    _vm.fundingDetailsDto.cb4xPopin
                                      .howToBenefit,
                                  cgu: _vm.fundingDetailsDto.cb4xPopin.cgu,
                                  illustration:
                                    _vm.fundingDetailsDto.cb4xPopin.imageZen,
                                },
                              })
                            : _vm.selectedFundingDetailVersion
                                .spreadingPrice4xCbWithoutFees
                            ? _c("cb4x-modal-content", {
                                attrs: {
                                  "header-block":
                                    _vm.fundingDetailsDto.cb4xPopin.headerBlock,
                                  "payment-block":
                                    _vm.fundingDetailsDto.cb4xPopin
                                      .paymentBlock,
                                  "payment-simulation-block":
                                    _vm.fundingDetailsDto.cb4xPopin
                                      .paymentSimulationBlock,
                                  "how-to-benefit":
                                    _vm.fundingDetailsDto.cb4xPopin
                                      .howToBenefit,
                                  faq: _vm.fundingDetailsDto.cb4xPopin.faqBlock,
                                  cgu: _vm.fundingDetailsDto.cb4xPopin.cgu,
                                  "monthly-price":
                                    _vm.selectedFundingDetailVersion
                                      .spreadingPrice4xCbWithoutFees
                                      .monthlyPrice,
                                  "first-monthly-price":
                                    _vm.selectedFundingDetailVersion
                                      .spreadingPrice4xCbWithoutFees
                                      .firstMonthlyPrice,
                                  "one-shot-price":
                                    _vm.selectedFundingDetailVersion
                                      .spreadingPrice4xCbWithoutFees
                                      .oneShotPrice,
                                  illustration:
                                    _vm.fundingDetailsDto.cb4xPopin.imageZen,
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
                _vm.selectedFundingDetailVersion.isPxfAvailable
                  ? {
                      key: "pxf-content",
                      fn: function () {
                        return [
                          _c("pxf-modal-content", {
                            attrs: {
                              "header-block-dto":
                                _vm.fundingDetailsDto.pxfPopin.headerBlockDto,
                              "example-pxf-data":
                                _vm.fundingDetailsDto.pxfPopin.examplePxfData,
                              "example-pxf-tab-subtitle":
                                _vm.fundingDetailsDto.pxfPopin
                                  .examplePxfTabSubtitle,
                              "example-pxf-tab-title":
                                _vm.fundingDetailsDto.pxfPopin
                                  .examplePxfTabTitle,
                              "version-pxf-data":
                                _vm.selectedFundingDetailVersion.versionPxfData,
                              "version-pxf-tab-title":
                                _vm.fundingDetailsDto.pxfPopin
                                  .versionPxfTabTitle,
                              "pxf-legal-mentions-text":
                                _vm.fundingDetailsDto.pxfPopin
                                  .pxfLegalMentionsText,
                              illustration:
                                _vm.fundingDetailsDto.pxfPopin.imageZen,
                              "financing-block":
                                _vm.fundingDetailsDto.pxfPopin.financingBlock,
                              cgu: _vm.fundingDetailsDto.pxfPopin.cguDto,
                              "how-to-benefit-dto":
                                _vm.fundingDetailsDto.pxfPopin.howToBenefitDto,
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }